import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiButton from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import LandingLayout from './components/LandingLayout';
import Section from './components/Section';

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();

  return (
    <LandingLayout>
      <Section background="#F8FAFD" py={{ xs: 8, md: 12 }}>
        <Box sx={{ textAlign: 'center', maxWidth: 600, mx: 'auto' }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              color: '#163567',
              mb: 2,
            }}
          >
            Welcome to Pressto!
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '1.05rem', md: '1.2rem' },
              color: '#555',
              lineHeight: 1.7,
              mb: 4,
            }}
          >
            Your subscription is active. Your 7-day free trial starts now — import your students and publish your first newspaper!
          </Typography>
          <MuiButton
            variant="contained"
            onClick={() => navigate('/login')}
            sx={{
              backgroundColor: '#2C2C2C',
              color: '#FFFFFF',
              border: '2px solid #1e1e1e',
              boxShadow: '3px 3px 0px #1e1e1e',
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              fontSize: '0.9rem',
              textTransform: 'none',
              borderRadius: '6px',
              px: 4,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#1e1e1e',
                boxShadow: '1px 1px 0px #1e1e1e',
                transform: 'translate(2px, 2px)',
              },
              transition: 'all 100ms ease-in-out',
            }}
          >
            Get Started
          </MuiButton>
        </Box>
      </Section>
    </LandingLayout>
  );
}
